/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */
import refreshSliders from './slider';
import {showOverlay, hideOverlay} from './overlay';

$(document).ready(() => {
  var ajaxTimeout = null;
  var AJAX_TIMEOUT_MS = 35000; // 35s (> 30s du MAX_EXECUTION_TIME MySQL)

  prestashop.on('updateFacets', () => {
    showOverlay();
    clearTimeout(ajaxTimeout);
    ajaxTimeout = setTimeout(function () {
      hideOverlay();
      showTimeoutError();
    }, AJAX_TIMEOUT_MS);
  });

  prestashop.on('updateProductList', () => {
    clearTimeout(ajaxTimeout);
    ajaxTimeout = null;
    hideOverlay();
    refreshSliders();
  });

  refreshSliders();

  // MDSA: Handle deferred faceted search on direct page load with ?q=
  // The page loaded as unfiltered (all products visible). Now trigger AJAX to apply filters.
  // setTimeout ensures all $(document).ready() handlers (especially the core.js AJAX handler
  // for updateFacets) have been registered before we emit the event.
  if (typeof facetedsearchDeferred !== 'undefined' && facetedsearchDeferred) {
    showOverlay();
    setTimeout(function () {
      prestashop.emit('updateFacets', window.location.href);
    }, 0);
  }

  function showTimeoutError() {
    var listEl = document.getElementById('js-product-list');
    if (listEl) {
      listEl.innerHTML =
        '<div class="alert alert-warning" style="margin: 2rem 0;">' +
        '<p style="margin-bottom: 1rem;">Le chargement des résultats a pris trop de temps. ' +
        'Essayez de réduire le nombre de filtres sélectionnés.</p>' +
        '<a href="' + window.location.pathname + '" class="btn btn-primary">' +
        'Voir tous les produits</a></div>';
    }
  }
});
